<template>
  <div class="sidebar -blog px-20">
    <!-------Search input--------------->
    <div class="nav-search">
      <div class="input-group">
        <input type="text" class="form-control pl-10 pr-35" placeholder="Username" aria-label="Username"
          aria-describedby="basic-addon1" />
        <span class="blog-search rotate-90" id="basic-addon1">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M15.5 14H14.71L14.43 13.73C15.444 12.5541 16.0012 11.0527 16 9.5C16 8.21442 15.6188 6.95772 14.9046 5.8888C14.1903 4.81988 13.1752 3.98676 11.9874 3.49479C10.7997 3.00282 9.49279 2.87409 8.23192 3.1249C6.97104 3.3757 5.81285 3.99477 4.90381 4.90381C3.99477 5.81285 3.3757 6.97104 3.1249 8.23192C2.87409 9.49279 3.00282 10.7997 3.49479 11.9874C3.98676 13.1752 4.81988 14.1903 5.8888 14.9046C6.95772 15.6188 8.21442 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z"
              fill="#B3B3B3" />
          </svg>
        </span>
      </div>
    </div>

    <div class="sidebar__item">
      <h5 class="sidebar__title">{{ $t('browseCategory') }}</h5>
      <div class="sidebar-content -list">
        <a href="#" v-for="category,i in categories" :key="i">{{ category?.label }}</a>
      </div>
    </div>

    <div class="sidebar__item mt-40">
     <h5 class="sidebar__title">{{ $t('recentPosts') }}</h5>

      <div class="sidebar-content -recent y-gap-20" >
        <!-----#1 Post start---------------->
        <div class="sidebar-recent d-flex items-start mt-12" v-for="item,i in spliceArray" :key="i">
          <router-link class="sidebar-recent__image mr-15" style="cursor: pointer;" :to="{ name: 'single-blog', params: { id: item.slug } }">
            <img :src="item?.cover" alt="image" />
          </router-link>

          <div class="sidebar-recent__content" >
            <h5 class="text-15 lh-15 fw-500">
              {{ item?.title }}
            </h5>
            <div class="d-flex justify-between flex-md-row flex-column align-items-start align-items-md-center mt-12">
              <div class="d-flex align-items-center" style="gap: 5px">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path
                    d="M10 2C11.2081 2.0007 12.4004 2.27501 13.4873 2.80234C14.5743 3.32967 15.5277 4.09633 16.276 5.04479C17.0243 5.99324 17.5481 7.09886 17.808 8.27868C18.0679 9.45849 18.0573 10.6819 17.7769 11.857C17.4964 13.0321 16.9535 14.1284 16.1888 15.0637C15.4241 15.999 14.4575 16.749 13.3616 17.2573C12.2656 17.7657 11.0688 18.0192 9.86083 17.9989C8.65289 17.9785 7.46524 17.6849 6.387 17.14L6.266 17.075L2.621 17.985C2.55085 18.0026 2.47771 18.0048 2.40662 17.9915C2.33554 17.9781 2.2682 17.9495 2.20926 17.9075C2.15032 17.8656 2.10117 17.8114 2.06522 17.7486C2.02926 17.6859 2.00735 17.6161 2.001 17.544V17.462L2.015 17.379L2.925 13.735L2.862 13.615C2.40552 12.7137 2.12389 11.7341 2.032 10.728L2.007 10.346L2 10C2 7.87827 2.84285 5.84344 4.34315 4.34315C5.84344 2.84285 7.87827 2 10 2ZM10 3C8.77846 2.9998 7.57814 3.31926 6.5183 3.92664C5.45847 4.53402 4.57603 5.40816 3.95866 6.46221C3.3413 7.51626 3.01051 8.71351 2.99917 9.93499C2.98782 11.1565 3.29632 12.3597 3.894 13.425C3.9404 13.5078 3.96225 13.6022 3.957 13.697L3.943 13.791L3.187 16.812L6.211 16.058C6.27247 16.0428 6.33627 16.0394 6.399 16.048L6.49 16.069L6.577 16.108C7.51034 16.6305 8.55102 16.9322 9.61911 16.9898C10.6872 17.0475 11.7543 16.8596 12.7385 16.4406C13.7226 16.0216 14.5977 15.3826 15.2964 14.5727C15.9952 13.7628 16.499 12.8036 16.7693 11.7687C17.0395 10.7337 17.069 9.6506 16.8555 8.60249C16.6419 7.55437 16.191 6.56914 15.5374 5.72244C14.8837 4.87574 14.0448 4.1901 13.0849 3.71816C12.1249 3.24622 11.0696 3.00055 10 3ZM10.5 11C10.6249 10.9998 10.7455 11.0463 10.8378 11.1305C10.9301 11.2147 10.9876 11.3304 10.9989 11.4548C11.0102 11.5793 10.9745 11.7034 10.8988 11.8028C10.8231 11.9023 10.7129 11.9697 10.59 11.992L10.5 12H7.5C7.37505 12.0002 7.25455 11.9537 7.16222 11.8695C7.06988 11.7853 7.01241 11.6696 7.00112 11.5452C6.98984 11.4207 7.02554 11.2966 7.10122 11.1972C7.1769 11.0977 7.28705 11.0303 7.41 11.008L7.5 11H10.5ZM12.5 8C12.6249 7.99977 12.7455 8.04633 12.8378 8.13051C12.9301 8.21469 12.9876 8.33039 12.9989 8.45482C13.0102 8.57926 12.9745 8.70341 12.8988 8.80283C12.8231 8.90225 12.7129 8.96974 12.59 8.992L12.5 9H7.5C7.37505 9.00023 7.25455 8.95367 7.16222 8.86949C7.06988 8.78531 7.01241 8.66961 7.00112 8.54518C6.98984 8.42074 7.02554 8.29659 7.10122 8.19717C7.1769 8.09775 7.28705 8.03026 7.41 8.008L7.5 8H12.5Z"
                    fill="#4D4D4D" />
                </svg>
                12
              </div>
              <div class="d-flex align-items-center" style="gap: 5px">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path
                    d="M16.2493 3.33341H13.7493V2.08341C13.7493 1.97291 13.7055 1.86693 13.6273 1.78879C13.5492 1.71065 13.4432 1.66675 13.3327 1.66675C13.2222 1.66675 13.1162 1.71065 13.0381 1.78879C12.9599 1.86693 12.916 1.97291 12.916 2.08341V3.33341H7.08268V2.08341C7.08268 1.97291 7.03878 1.86693 6.96064 1.78879C6.8825 1.71065 6.77652 1.66675 6.66602 1.66675C6.55551 1.66675 6.44953 1.71065 6.37139 1.78879C6.29325 1.86693 6.24935 1.97291 6.24935 2.08341V3.33341H3.74935C3.19702 3.33408 2.6675 3.55378 2.27694 3.94434C1.88638 4.3349 1.66668 4.86442 1.66602 5.41675V16.2501C1.66668 16.8024 1.88638 17.3319 2.27694 17.7225C2.6675 18.113 3.19702 18.3328 3.74935 18.3334H16.2493C16.8019 18.3334 17.3318 18.1139 17.7225 17.7232C18.1132 17.3325 18.3327 16.8026 18.3327 16.2501V5.41675C18.3327 4.86421 18.1132 4.33431 17.7225 3.94361C17.3318 3.55291 16.8019 3.33341 16.2493 3.33341ZM17.4993 16.2501C17.4993 16.5816 17.3677 16.8995 17.1332 17.134C16.8988 17.3684 16.5809 17.5001 16.2493 17.5001H3.74935C3.41783 17.5001 3.09989 17.3684 2.86547 17.134C2.63105 16.8995 2.49935 16.5816 2.49935 16.2501V9.16675H17.4993V16.2501ZM17.4993 8.33342H2.49935V5.41675C2.49935 4.72675 3.05768 4.16675 3.74935 4.16675H6.24935V5.41675C6.24935 5.52726 6.29325 5.63324 6.37139 5.71138C6.44953 5.78952 6.55551 5.83342 6.66602 5.83342C6.77652 5.83342 6.8825 5.78952 6.96064 5.71138C7.03878 5.63324 7.08268 5.52726 7.08268 5.41675V4.16675H12.916V5.41675C12.916 5.52726 12.9599 5.63324 13.0381 5.71138C13.1162 5.78952 13.2222 5.83342 13.3327 5.83342C13.4432 5.83342 13.5492 5.78952 13.6273 5.71138C13.7055 5.63324 13.7493 5.52726 13.7493 5.41675V4.16675H16.2493C16.5809 4.16675 16.8988 4.29844 17.1332 4.53286C17.3677 4.76729 17.4993 5.08523 17.4993 5.41675V8.33342Z"
                    fill="#4D4D4D" />
                </svg>
                {{ item?.date }}
              </div>
            </div>
          </div>
        </div>
        <!-----#1 Post end---------------->
      </div>
    </div>

    <!-- <div class="sidebar__item">
     <h5 class="sidebar__title">{{ $t('sidebar.tags') }}</h5>

      <div class="sidebar-content -tags">
        <div class="sidebar-tag">
          <a class="text-14 fw-500" href="#">Courses</a>
        </div>

        <div class="sidebar-tag">
          <a class="text-14 fw-500" href="#">Learn</a>
        </div>

        <div class="sidebar-tag">
          <a class="text-14 fw-500" href="#">Online</a>
        </div>

        <div class="sidebar-tag">
          <a class="text-14 fw-500" href="#">Education</a>
        </div>

        <div class="sidebar-tag">
          <a class="text-14 fw-500" href="#">LMS</a>
        </div>

        <div class="sidebar-tag">
          <a class="text-14 fw-500" href="#">Training</a>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const categories = computed(() => store.getters.categories);

const props = defineProps({
  relatedPosts: {
    type: Array,
    default: () => []
  }
});

// use slice to avoid mutating props
const spliceArray = computed(() => props.relatedPosts.slice(0, 3));
</script>

<style lang="scss" scoped>
.rotate-90 {
  right: 5px !important;
}
</style>
